import { Modal, Button } from "react-bootstrap";
import { lddStateObject, setThirdPartyListState } from "../../../redux/reducer";
import { useAppSelector } from "../../../redux/hooks";
import { useContext } from "react";
import { useDispatch } from 'react-redux';
import { NavObjectType } from "../../navigationTypes";
import { NavigationContext } from "../../../Context/NavigationContext";
import { RPWDataReader, getDataReader } from "../../../livedataFuncs";

const DisconnectModal = () => {
    // const show = useAppSelector((state: lddStateObject) => state.ThirdPartyListState === "showDRDisconnect");
    const livedataRoot = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer?.dataRoot);
    const processor: RPWDataReader = getDataReader(livedataRoot);
    const dispatch = useDispatch();
    const nav = useContext(NavigationContext);
    const dismissModal = () => {
        dispatch(setThirdPartyListState(null));
    }
    const unlinkNewHomeProj = () => {
        dismissModal();
        let navObj: NavObjectType = {
            component: "main",
            url: "lfmaster.asp",
            controller: {
                tabName: "Basic",
                tabNumber: 0,
                refresh: true
            },
            params: {
                formasp: "purfileedit",
                tb: "TPAppXML",
                id: processor.getAppId(),
                onload: `livedataRoot.removeChild(livedataRoot.selectSingleNode("VIPInfo"));SetPageDirty();`,
                ReactDocument: "-1"
            },
        }
        nav(navObj);
    }

    return <Modal centered show={true}>
    <Modal.Header>
        <h2>Confirm Disconnect</h2>
    </Modal.Header>
    <Modal.Body>
        <p>Are you sure you want to disconnect this file from builder project <b>{processor.getVIPInfoProjName()}</b>? Information already synced with this file will <b>not</b> be removed.</p>
    </Modal.Body>
    <Modal.Footer>
            <>
                <Button variant="outline-primary" className="cancel-button" onClick={dismissModal}>Cancel</Button>                        
                <Button variant="primary" onClick={unlinkNewHomeProj}>Confirm</Button>
            </>
    </Modal.Footer>
</Modal>
}

export default DisconnectModal;